import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { getEffectiveCompanyId, hasCompanyAccess, needsOnboarding } from '../utils/userCompany';
import { getEffectiveCompanyRole } from '../utils/planAccess';
import PageLoader from './PageLoader';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();
  const effectiveCompanyId = getEffectiveCompanyId(user);
  const onboardingExemptPaths = ['/onboarding', '/accept-invitation', '/users/edit', '/no-company', '/support'];

  if (loading) {
    return <PageLoader />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (needsOnboarding(user) && !onboardingExemptPaths.includes(location.pathname)) {
    return <Navigate to="/onboarding" replace />;
  }

  if (!needsOnboarding(user) && (!user.first_name || !user.last_name) && location.pathname !== '/users/edit') {
    return <Navigate to="/users/edit" replace />;
  }

  if (
    user.role === 'super_admin'
    && !effectiveCompanyId
    && location.pathname !== '/super-admin'
    && location.pathname !== '/users/edit'
    && location.pathname !== '/support'
    && location.pathname !== '/companies'
    && location.pathname !== '/users'
  ) {
    return <Navigate to="/super-admin" replace />;
  }

  if (
    !hasCompanyAccess(user)
    && user.role !== 'super_admin'
    && !needsOnboarding(user)
    && !onboardingExemptPaths.includes(location.pathname)
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  if (effectiveCompanyId && location.pathname === '/no-company') {
    return <Navigate to="/dashboard" replace />;
  }

  if (effectiveCompanyId && user.role === 'super_admin' && location.pathname === '/super-admin') {
    return <Navigate to="/dashboard" replace />;
  }

  if (!needsOnboarding(user) && location.pathname === '/onboarding') {
    return <Navigate to="/dashboard" replace />;
  }

  const effectiveRole = getEffectiveCompanyRole(user);

  if (allowedRoles.length > 0 && !allowedRoles.includes(effectiveRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PrivateRoute;
